// Temporary client-side stand-in for tracking which models already have a posted
// designer-assistance project. These localStorage keys are for testing only and
// will not be migrated; a backend-provided field will drive this in production.

const KEY_PREFIX = 'ai_studio_assist_posted:'

const keyFor = modelId => `${KEY_PREFIX}${modelId}`

export const isProjectPosted = (modelId) => {
  if (modelId == null) return false

  try {
    return window.localStorage.getItem(keyFor(modelId)) === 'true'
  } catch (e) {
    return false
  }
}

export const markProjectPosted = (modelId) => {
  if (modelId == null) return

  try {
    window.localStorage.setItem(keyFor(modelId), 'true')
  } catch (e) {
    // Ignore quota/private-mode errors; persistence is best-effort and test-only.
  }
}
